import React from 'react';
import { styled, tableCellClasses } from '@mui/material';
// table
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

const NOT_AVAILABLE = 'N/A';

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 12,
    padding: '6px',
    height: '42.5px',
    fontWeight: 500,
    textTransform: 'uppercase',
    color: '#0d4689'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
    padding: '4px 6px',
    height: '42.5px'
  }
}));
/**
 * DynamicTable Component
 * @param {Array} columns - Array of column definitions { label: string, key: string, align?: string, formatter?: function }
 * @param {Array} data - Array of row objects
 */

// const columns = [
//   { label: "Call Date", key: "callDateTime", formatter: fDate },
//   { label: "Call Agent", key: "callAgentName" },
//   { label: "Status", key: "callStatus" },
//   { label: "Comments", key: "callComments" },
// ];

export default function CustomTableComponent({ columns = [], data = [] }) {
  return (
    <TableContainer sx={{ minWidth: 800, overflow: 'auto', background: 'white' }}>
      <Table>
        <TableHead>
          <TableRow>
            {columns.map((col, index) => (
              <StyledTableCell key={index} align={col.align || 'left'}>
                {col.label}
              </StyledTableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.length > 0 ? (
            data.map((row, rowIndex) => (
              <StyledTableRow key={rowIndex}>
                {columns.map((col, colIndex) => (
                  <StyledTableCell key={colIndex} align={col.align || 'left'}>
                    {row[col.key]
                      ? col.formatter
                        ? col.formatter(row[col.key], row)
                        : row[col.key]
                      : NOT_AVAILABLE}
                  </StyledTableCell>
                ))}
              </StyledTableRow>
            ))
          ) : (
            <StyledTableRow>
              <StyledTableCell colSpan={columns.length} align="center">
                No records found
              </StyledTableCell>
            </StyledTableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
